import {SecureService} from "@/services/superclasses/secure-service";
import {Bookmark} from "@/interfaces/bookmark";

const api = window.contextPath + '/rest/bookmarks';

export class BookmarkSecureService extends SecureService {

    constructor() {
        super();
    }

    public createArticle = async (articleId: number): Promise<Bookmark> => {
        return this.data(await this.put<Bookmark>(api + "/articles/" + articleId));
    }

    public createPost = async (postId: number): Promise<Bookmark> => {
        return this.data(await this.put<Bookmark>(api + "/posts/" + postId))
    }

    public remove = async (id: number): Promise<void> => {
        return this.data(await this.delete(api + "/" + id));
    }

    public removeArticle = async (id: number): Promise<void> => {
        return this.data(await this.delete(api + "/articles/" + id));
    }

    public removePost = async (id: number): Promise<void> => {
        return this.data(await this.delete(api + "/posts/" + id));
    }

    public checkArticles = async (articleIds: number[]): Promise<Record<number, boolean>> => {
        if (!articleIds || articleIds.length == 0) {
            return {};
        }

        const query = articleIds.join(",");

        return this.data(await this.get<Record<number, boolean>>(api + "/articles/check",
            {
                params: {
                    articles: query
                }
            }))
    }

    public checkPosts = async (postIds: number[]): Promise<Record<number, boolean>> => {
        if (!postIds || postIds.length == 0) {
            return {};
        }

        const query = postIds.join(",");

        return this.data(await this.get<Record<number, boolean>>(api + "/posts/check",
            {
                params: {
                    posts: query
                }
            }))
    }

    public search = async (args: {
        q?: string,
        sort?: string,
        first?: number,
        max?: number
    }): Promise<Bookmark[]> => {
        return this.data(await this.get<Bookmark[]>(api + "/",
            {
                params: args
            }))
    }

    public count = async (args: {
        q?: string
    }): Promise<number> => {
        return this.data(await this.get<number>(api + "/count",
            {
                params: args
            }))
    }
}

export const bookmarkSecureService = new BookmarkSecureService()